import SelectRow from '@dc-shared-web/components/features/AIConfigDialog/SelectRow'
import {
  AIConfigModalProvider,
  AIConfigModalValues,
} from '@dc-shared-web/components/features/AIConfigDialog/types'

const LanguageModelProviderRow = ({
  values,
  disabled,
  providers,
  onChange,
}: {
  values: AIConfigModalValues
  providers: AIConfigModalProvider[]
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (value: string) => {
    onChange({ ...values, provider: value })
  }

  return (
    <SelectRow
      label='Language model provider'
      value={values.provider ?? ''}
      options={providers.map((provider) => ({
        value: provider.id,
        text: provider.name,
      }))}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}

export default LanguageModelProviderRow
